/* GriffinMainHeader.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2MUDv%7Bgrid-template-columns%3A1fr%20auto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GBAIrogpp%3Aafter%7Bcontent%3A%22%22%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WYcYGWVPG%3Aafter%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._47eTBtHZdu%3Aafter%7Bheight%3A1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3wEj0XKcZT%3Aafter%7Bbackground-color%3Avar(--ds-background-neutral-hovered%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3ufiZDPgdg%3Aafter%7Binset-block-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2jfUf9qFIo%3Aafter%7Bwidth%3Acalc(100%25%20-%201px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._13xWvlHZdu%3Aafter%7Binset-inline-start%3A1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%7B._3iQH9H5zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D._0E0eqlNHnM%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D._0oYdj6Yab0%7Bgrid-template-areas%3A%22breadcrumbs%22%20%22title%22%20%22actions%22%20%22tabs%22%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A48rem)%7B._1TZlheVa5s%7Bpadding-inline%3Avar(--ds-space-400%2C2pc)%7D._4vrR4lNHnM%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D._4ek1Js5mQj%7Bgrid-template-areas%3A%22breadcrumbs%20actions%22%20%22title%20actions%22%20%22tabs%20tabs%22%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%7B._3iQH9H5zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D._0E0eqlNHnM%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D._0XxGBvNHnM%7Bpadding-block-end%3Avar(--ds-space-300%2C24px)%7D._0oYdj6Yab0%7Bgrid-template-areas%3A%22breadcrumbs%22%20%22title%22%20%22actions%22%20%22tabs%22%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A48rem)%7B._1TZlheVa5s%7Bpadding-inline%3Avar(--ds-space-400%2C2pc)%7D._4vrR4lNHnM%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D._4DW1KGNHnM%7Bpadding-block-end%3Avar(--ds-space-300%2C24px)%7D._4ek1Js5mQj%7Bgrid-template-areas%3A%22breadcrumbs%20actions%22%20%22title%20actions%22%20%22tabs%20tabs%22%7D%7D");
import React from 'react';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { Grid as LegacyGrid } from '@atlaskit/primitives/grid';
import { media } from '@atlaskit/primitives/responsive/media';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { fg } from '@townsquare/stat-sig/gate';
const styles = xcss({
  position: 'relative',
  gridTemplateColumns: '1fr auto',
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
  [media.above.xxs]: {
    paddingBlockStart: 'space.300',
    paddingInline: 'space.200',
    gridTemplateAreas: `
      "breadcrumbs"
      "title"
      "actions"
      "tabs"
    `
  },
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
  [media.above.sm]: {
    paddingBlockStart: 'space.300',
    paddingInline: 'space.400',
    gridTemplateAreas: `
      "breadcrumbs actions"
      "title actions"
      "tabs tabs"
    `
  },
  ':after': {
    content: '""',
    position: 'absolute',
    height: '1px',
    backgroundColor: 'color.background.neutral.hovered',
    insetBlockEnd: 'space.0',
    // Ensures border won't overflow on top of sidenav
    width: 'calc(100% - 1px)',
    insetInlineStart: '1px'
  }
});
const stylesNoTabs = xcss({
  position: 'relative',
  gridTemplateColumns: '1fr auto',
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
  [media.above.xxs]: {
    paddingBlockStart: 'space.300',
    paddingBlockEnd: 'space.300',
    paddingInline: 'space.200',
    gridTemplateAreas: `
      "breadcrumbs"
      "title"
      "actions"
      "tabs"
    `
  },
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
  [media.above.sm]: {
    paddingBlockStart: 'space.300',
    paddingBlockEnd: 'space.300',
    paddingInline: 'space.400',
    gridTemplateAreas: `
      "breadcrumbs actions"
      "title actions"
      "tabs tabs"
    `
  },
  ':after': {
    content: '""',
    position: 'absolute',
    height: '1px',
    backgroundColor: 'color.background.neutral.hovered',
    insetBlockEnd: 'space.0',
    // Ensures border won't overflow on top of sidenav
    width: 'calc(100% - 1px)',
    insetInlineStart: '1px'
  }
});
const compiledStyles = {
  root: "_1mT5xdRAKS _2iEGP2MUDv _0GBAIrogpp _2WYcYGWVPG _47eTBtHZdu _3wEj0XKcZT _3ufiZDPgdg _2jfUf9qFIo _13xWvlHZdu _3iQH9H5zaO _0E0eqlNHnM _0oYdj6Yab0 _1TZlheVa5s _4vrR4lNHnM _4ek1Js5mQj",
  noTabs: "_1mT5xdRAKS _2iEGP2MUDv _0GBAIrogpp _2WYcYGWVPG _47eTBtHZdu _3wEj0XKcZT _3ufiZDPgdg _2jfUf9qFIo _13xWvlHZdu _3iQH9H5zaO _0E0eqlNHnM _0XxGBvNHnM _0oYdj6Yab0 _1TZlheVa5s _4vrR4lNHnM _4DW1KGNHnM _4ek1Js5mQj"
};
export const GriffinMainHeader = ({
  children,
  noTabs
}: React.PropsWithChildren<{
  noTabs?: boolean;
}>): React.JSX.Element => {
  return fg('townsquare-compiled-xcss-to-cssmap-final') ? <Grid xcss={noTabs ? compiledStyles.noTabs : compiledStyles.root}>{children}</Grid> : <LegacyGrid xcss={noTabs ? stylesNoTabs : styles}>{children}</LegacyGrid>;
};